// extracted by mini-css-extract-plugin
export default {"PurchaseList":"PurchaseList_PurchaseList__fZzOD","List":"PurchaseList_List__BafsB","LoadingContainer":"PurchaseList_LoadingContainer__IMxuO"};